import MAdmin from './admin.menu'
import MLogisticsOfficer from './logistics-officer.menu'
import MUser from './user.menu'

export const getSidebarMenus = user => {
  switch (user.role) {
    case 'admin': {
      return MAdmin
    }
    case 'logistics-officer': {
      return MLogisticsOfficer
    }
    case 'user': {
      return MUser
    }
    default: {
      return []
    }
  }
}
